// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__1gXJH","content":"Hero_content__13bXY","buttonContainer":"Hero_buttonContainer__3yQNs","btn":"Hero_btn__1B9AM"};